/* eslint-disable fp/no-loops */
/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-mutating-methods */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable fp/no-let */
import uniqueId from 'lodash/uniqueId';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import Day from './Day';

const DAYS = 7;

export const getWeeksForMonth = (month, enableOutsideDays) => {
  const baseDate = moment(month).clone();
  const firstOfMonth = baseDate.clone().startOf('month');
  const lastOfMonth = baseDate.clone().endOf('month').startOf('day');

  const currentDay = firstOfMonth.clone();
  let currentWeek = [];
  const weeksInMonth = [];

  for (let i = 0; i < currentDay.weekday(); i += 1) {
    const prevDay = enableOutsideDays ? currentDay.clone().subtract(i + 1, 'day') : null;
    currentWeek.unshift(prevDay);
  }

  while (currentDay <= lastOfMonth) {
    currentWeek.push(currentDay.clone());
    currentDay.add(1, 'd');
    if (currentDay.weekday() === 0) {
      weeksInMonth.push(currentWeek);
      currentWeek = [];
    }
  }

  if (currentDay.weekday() !== 0) {
    for (let k = currentDay.weekday(), count = 0; k < DAYS; k += 1, count += 1) {
      const nextDay = enableOutsideDays ? currentDay.clone().add(count, 'day') : null;
      currentWeek.push(nextDay);
    }
    weeksInMonth.push(currentWeek);
  }
  return weeksInMonth;
};

export const isSelectedDay = (day, selectedDates) => {
  if (selectedDates instanceof moment) {
    return day && selectedDates && selectedDates.isSame(day, 'day');
  }
  return day && Object.values(selectedDates).some((d) => d && d.isSame(day, 'day'));
};

const getDayProps = (day, month, selectedDates, earliestDateTime, latestDateTime) => {
  const isDayOutsideOfMonth = !day || day.month() !== month.month();
  const isDayWithinRange = day && selectedDates.end && day.isBetween(selectedDates.start, selectedDates.end);
  const isDaySelectable = !((earliestDateTime && day && day.isBefore(earliestDateTime, 'day')) || (latestDateTime && day && day.isAfter(latestDateTime, 'day')));

  return {
    isDayInRange: isDayWithinRange,
    isDayOutsideOfMonth,
    isDaySelectable,
    isSelected: isSelectedDay(day, selectedDates),
    isToday: day && day.format('MM-DD-YYYY') === moment().format('MM-DD-YYYY'),
  };
};

const Month = ({
  earliestDateTime, enableOutsideDays, handleDayClick, handleKeyDownOnDay, latestDateTime, month, selectedDates,
}) => {
  const weeks = getWeeksForMonth(month, enableOutsideDays);
  return (
    <div className="pt2-sm">
      <table className="d-sm-ib">
        <thead className="text-color-secondary">
          <tr>
            <th>Sun</th>
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thur</th>
            <th>Fri</th>
            <th>Sat</th>
          </tr>
        </thead>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/no-noninteractive-tabindex */}
        <tbody tabIndex="0" onKeyDown={handleKeyDownOnDay}>
          {weeks.map((week) => (
            <tr key={`week-of-${week.find((d) => d).format('MMM-D')}`}>
              {week.map((day) => (
                <Day
                  key={day ? day.format('MMM-Do') : uniqueId()}
                  day={day}
                  handleDayClick={handleDayClick}
                  {...getDayProps(day, month, selectedDates, earliestDateTime, latestDateTime)}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

Month.propTypes = {
  earliestDateTime: PropTypes.shape(),
  enableOutsideDays: PropTypes.bool.isRequired,
  handleDayClick: PropTypes.func.isRequired,
  handleKeyDownOnDay: PropTypes.func.isRequired,
  latestDateTime: PropTypes.shape(),
  month: PropTypes.shape().isRequired,
  selectedDates: PropTypes.shape().isRequired,
};

Month.defaultProps = {
  earliestDateTime: {},
  latestDateTime: {},
};

export default Month;
